import React from "react";
import { getJobTitleLabel } from "../../../utils/jobTitleLabel";

const JobHeader = ({ navigateBack, isEditMode, isDraftMode, saveDraft }) => {
    const jobLabel = getJobTitleLabel();

    const shouldRenderSaveDraftButton = () => {
      if (!isEditMode) {
        return true;
      }
      if (isDraftMode) {
        return true;
      }
      return false;
    };
  
    return (
      <div className="sticky top-0 bg-white border-b border-accent-light z-10">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <div className="flex items-center space-x-4">
                <button
                  onClick={() => navigateBack()}
                  className="p-2 rounded-full hover:bg-accent-light/20 transition-colors"
                >
                  <svg className="w-5 h-5 text-primary-headings" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                </button>
                <h1 className="text-xl font-semibold text-primary-headings">
                  {isEditMode
                    ? isDraftMode
                      ? `Create ${jobLabel} From Draft`
                      : `Edit ${jobLabel}`
                    : `Create ${jobLabel}`}
                </h1>
              </div>
              
              {/* Add top action buttons for draft functionality */}
              {shouldRenderSaveDraftButton() && (
                <div className="flex items-center space-x-4">
                  <button
                    type="button"
                    onClick={saveDraft}
                    className="px-6 py-2.5 border border-accent-light/30 rounded-lg text-accent-dark hover:bg-accent-light/5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent-light transition-colors duration-200"
                  >
                    Save Draft & Close
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
    );
};

export default JobHeader;